<template>
    <Transition name="modal-fade">
        <div v-if="isdisplay" class="cf-overlay" @click.self="close">
            <Transition name="modal-slide">
                <div v-if="isdisplay" class="cf-dialog cf-dialog--xl">

                    <!-- Header -->
                    <div class="cf-modal-head cf-dialog-head">
                        <div class="cf-modal-head__main">
                            <span class="cf-modal-head__icon"><i class="ri-file-list-3-line"></i></span>
                            <div>
                                <h4 class="cf-dialog-title">{{ titlemodal }}</h4>
                                <p class="cf-modal-head__sub">Détail du document commercial</p>
                            </div>
                        </div>
                        <button @click="close" type="button" class="cf-dialog-close" aria-label="Fermer"><i class="ri-close-line"></i></button>
                    </div>

                    <!-- Body -->
                    <div class="cf-dialog-body">

                        <div v-if="messagesucces !== ''" class="cf-note cf-note--info" style="margin-bottom:0.75rem;">
                            <i class="ri-check-circle-line"></i><span>{{ messagesucces }}</span>
                        </div>
                        <div v-if="messageerror !== ''" class="cf-note cf-note--danger" style="margin-bottom:0.75rem;">
                            <i class="ri-error-warning-line"></i><span>{{ messageerror }}</span>
                        </div>

                        <div class="cf-note cf-note--info" style="margin-bottom:0.75rem;">
                            <i class="ri-information-line"></i>
                            <span>N° document : <strong>{{ Items.docnum }}</strong></span>
                        </div>

                        <!-- Onglets -->
                        <div class="cf-tabs" aria-label="Tabs">
                            <button type="button" class="cf-tab active"
                                    id="geshs-tab-js-behavior-item-1" data-hs-tab="#geshs-tab-js-behavior-1" aria-controls="geshs-tab-js-behavior-1">
                                Information de base
                            </button>
                            <button type="button" class="cf-tab"
                                    id="geshs-tab-js-behavior-item-2" data-hs-tab="#geshs-tab-js-behavior-2" aria-controls="geshs-tab-js-behavior-2">
                                Pieds de document, date de livraison,...
                            </button>
                            <button type="button" class="cf-tab"
                                    id="geshs-tab-js-behavior-item-3" data-hs-tab="#geshs-tab-js-behavior-3" aria-controls="geshs-tab-js-behavior-3">
                                Information libre
                            </button>
                            <button type="button" class="cf-tab"
                                    id="geshs-tab-js-behavior-item-4" data-hs-tab="#geshs-tab-js-behavior-4" aria-controls="geshs-tab-js-behavior-4">
                                Adresse d'expédition
                            </button>
                        </div>

                        <div class="cf-tabpanels">

                            <div id="geshs-tab-js-behavior-1" role="tabpanel" aria-labelledby="geshs-tab-js-behavior-item-1">

                                <div class="grid lg:grid-cols-2 gap-4">

                                    <div class="space-y-2">
                                        <label class="cf-field-label">Magasin / Dépôt / Entrepôt</label>
                                        <input :value="Items.mag.name" type="text" disabled class="cf-inp" required>
                                    </div>

                                    <div class="space-y-2">
                                        <label class="cf-field-label">Date</label>
                                        <input :value="Items.datedoc" disabled type="date" class="cf-inp" required>
                                    </div>

                                    <div class="space-y-2">
                                        <div class="grid grid-cols-12 gap-x-3">
                                            <div class="xl:col-span-10 col-span-12">
                                                <label v-if="typededocument==='vente'" class="cf-field-label">Client</label>
                                                <label v-else class="cf-field-label">Fournisseur</label>
                                                <input :value="Items.jsonotherdonne.cltfrs.name" type="text" class="cf-inp" disabled>
                                            </div>
                                            <div class="xl:col-span-2 col-span-12">
                                                <label class="cf-field-label">&nbsp;</label>
                                                <button disabled type="button" class="ds-btn-ghost" style="width:100%;justify-content:center;height:40px;">...</button>
                                            </div>
                                        </div>
                                    </div>

                                    <div v-if="typededocument==='vente'" class="space-y-2">
                                        <label class="cf-field-label">Type de prix</label>
                                        <select disabled class="cf-inp">
                                            <option :selected="Items.jsonotherdonne.mtypprixdevente==='prixvente'?'selected':''" value="prixvente">{{datainputlibelleforms.prixvente}}</option>
                                            <option :selected="Items.jsonotherdonne.mtypprixdevente==='prixvente1'?'selected':''" value="prixvente1">{{datainputlibelleforms.prixvente1}}</option>
                                            <option :selected="Items.jsonotherdonne.mtypprixdevente==='prixvente2'?'selected':''" value="prixvente2">{{datainputlibelleforms.prixvente2}}</option>
                                            <option :selected="Items.jsonotherdonne.mtypprixdevente==='prixvente3'?'selected':''" value="prixvente3">{{datainputlibelleforms.prixvente3}}</option>
                                            <option :selected="Items.jsonotherdonne.mtypprixdevente==='prixvente4'?'selected':''" value="prixvente4">{{datainputlibelleforms.prixvente4}}</option>
                                            <option :selected="Items.jsonotherdonne.mtypprixdevente==='prixvente5'?'selected':''" value="prixvente5">{{datainputlibelleforms.prixvente5}}</option>
                                            <option :selected="Items.jsonotherdonne.mtypprixdevente==='prixvente6'?'selected':''" value="prixvente6">{{datainputlibelleforms.prixvente6}}</option>
                                            <option :selected="Items.jsonotherdonne.mtypprixdevente==='prixvente7'?'selected':''" value="prixvente7">{{datainputlibelleforms.prixvente7}}</option>
                                        </select>
                                    </div>

                                </div>

                                <div v-if="typededocument==='vente'" class="space-y-2 mt-3">
                                    <label class="cf-field-label">Collaborateur</label>
                                    <input v-if="Items.jsonotherdonne.collaborateur===null" :value="Items.jsonotherdonne.cltfrs.name" type="text" class="cf-inp" disabled>
                                    <input v-else :value="Items.jsonotherdonne.collaborateur.name" type="text" class="cf-inp" disabled>
                                </div>

                                <div class="space-y-2 mt-3">
                                    <label class="cf-field-label">Motif / Raison</label>
                                    <textarea :value="Items.docobservation" disabled class="cf-inp cf-textarea" cols="15" rows="3"></textarea>
                                </div>

                            </div>

                            <div id="geshs-tab-js-behavior-2" role="tabpanel" aria-labelledby="geshs-tab-js-behavior-item-2" class="hidden">

                                <div class="grid lg:grid-cols-2 gap-4">

                                    <div class="space-y-2">
                                        <label class="cf-field-label">Appliquer la TVA(18%) sur ce document</label>
                                        <input :value="(Items.jsonotherdonne.appliquetva===0 || Items.jsonotherdonne.appliquetva==='0')?'Non':'Oui' " type="text" disabled class="cf-inp" required>
                                    </div>

                                    <div class="space-y-2">
                                        <label class="cf-field-label">AIB</label>
                                        <select disabled class="cf-inp">
                                            <option :selected="Items.jsonotherdonne.aib==='0'?'selected':''" value="0"></option>
                                            <option :selected="Items.jsonotherdonne.aib==='1'?'selected':''" value="1">AIB (1%)</option>
                                            <option :selected="Items.jsonotherdonne.aib==='3'?'selected':''" value="3">AIB (3%)</option>
                                            <option :selected="Items.jsonotherdonne.aib==='5'?'selected':''" value="5">AIB (5%)</option>
                                        </select>
                                    </div>

                                    <div class="space-y-2">
                                        <label class="cf-field-label">Mode de réglement</label>
                                        <input :value="(Items.jsonotherdonne.moderglt!==null)?Items.jsonotherdonne.moderglt.name:'' " type="text" disabled class="cf-inp" required>
                                    </div>

                                    <div class="space-y-2">
                                        <label class="cf-field-label">Condiction de réglement</label>
                                        <input :value="(Items.jsonotherdonne.cdtreglement!==null)?Items.jsonotherdonne.cdtreglement.name:'' " type="text" disabled class="cf-inp" required>
                                    </div>

                                    <div class="space-y-2">
                                        <label class="cf-field-label">Date de livraison (bon de reception et bon de livraison client)</label>
                                        <input disabled :value="Items.jsonotherdonne.datedelivraison" type="date" class="cf-inp" required>
                                    </div>

                                    <div class="space-y-2">
                                        <label class="cf-field-label">Echéancier (bon de commande frs et facture client)</label>
                                        <input disabled :value="Items.jsonotherdonne.dateechancefacture" type="date" class="cf-inp" required>
                                    </div>

                                    <div class="space-y-2">
                                        <label class="cf-field-label">Information libre(Avance)</label>
                                        <input disabled :value="Items.jsonotherdonne.piedsinfodoc.infolibre" type="text" class="cf-inp" required>
                                    </div>

                                    <div class="space-y-2">
                                        <label class="cf-field-label">Information libre 1 (Solde)</label>
                                        <input disabled :value="Items.jsonotherdonne.piedsinfodoc.infolibre1" type="text" class="cf-inp" required>
                                    </div>

                                    <div class="space-y-2">
                                        <label class="cf-field-label">Information libre 2</label>
                                        <input disabled :value="Items.jsonotherdonne.piedsinfodoc.infolibre2" type="text" class="cf-inp" required>
                                    </div>

                                    <div class="space-y-2">
                                        <label class="cf-field-label">Information libre 3</label>
                                        <input disabled :value="Items.jsonotherdonne.piedsinfodoc.infolibre3" type="text" class="cf-inp" required>
                                    </div>

                                </div>

                            </div>

                            <div id="geshs-tab-js-behavior-3" role="tabpanel" aria-labelledby="geshs-tab-js-behavior-item-3" class="hidden">

                                <div class="grid lg:grid-cols-2 gap-4">

                                    <div class="space-y-2">
                                        <label class="cf-field-label">Information libre</label>
                                        <input disabled :value="Items.jsonotherdonne.infodoc.infolibre" type="text" class="cf-inp" required>
                                    </div>

                                    <div class="space-y-2">
                                        <label class="cf-field-label">Information libre 1</label>
                                        <input disabled :value="Items.jsonotherdonne.infodoc.infolibre1" type="text" class="cf-inp" required>
                                    </div>

                                    <div class="space-y-2">
                                        <label class="cf-field-label">Information libre 2</label>
                                        <input disabled :value="Items.jsonotherdonne.infodoc.infolibre2" type="text" class="cf-inp" required>
                                    </div>

                                    <div class="space-y-2">
                                        <label class="cf-field-label">Information libre 3</label>
                                        <input disabled :value="Items.jsonotherdonne.infodoc.infolibre3" type="text" class="cf-inp" required>
                                    </div>

                                    <div class="space-y-2">
                                        <label class="cf-field-label">Information libre 4</label>
                                        <input disabled :value="Items.jsonotherdonne.infodoc.infolibre4" type="text" class="cf-inp" required>
                                    </div>

                                    <div class="space-y-2">
                                        <label class="cf-field-label">Information libre 5</label>
                                        <input disabled :value="Items.jsonotherdonne.infodoc.infolibre5" type="text" class="cf-inp" required>
                                    </div>

                                    <div class="space-y-2">
                                        <label class="cf-field-label">Information libre 6</label>
                                        <input disabled :value="Items.jsonotherdonne.infodoc.infolibre6" type="text" class="cf-inp" required>
                                    </div>

                                    <div class="space-y-2">
                                        <label class="cf-field-label">Information libre 7</label>
                                        <input disabled :value="Items.jsonotherdonne.infodoc.infolibre7" type="text" class="cf-inp" required>
                                    </div>

                                    <div class="space-y-2">
                                        <label class="cf-field-label">Information libre 8</label>
                                        <input disabled :value="Items.jsonotherdonne.infodoc.infolibre8" type="text" class="cf-inp" required>
                                    </div>

                                    <div class="space-y-2">
                                        <label class="cf-field-label">Information libre 9</label>
                                        <input disabled :value="Items.jsonotherdonne.infodoc.infolibre9" type="text" class="cf-inp" required>
                                    </div>

                                    <div class="space-y-2">
                                        <label class="cf-field-label">Information libre 10</label>
                                        <input disabled :value="Items.jsonotherdonne.infodoc.infolibre10" type="text" class="cf-inp" required>
                                    </div>

                                </div>

                            </div>

                            <div id="geshs-tab-js-behavior-4" role="tabpanel" aria-labelledby="geshs-tab-js-behavior-item-4" class="hidden">

                                <div class="grid lg:grid-cols-2 gap-4">

                                    <div class="space-y-2">
                                        <label class="cf-field-label">Adresse</label>
                                        <input disabled :value="Items.jsonotherdonne.adresseexpedition.infolibre" type="text" class="cf-inp" required>
                                    </div>

                                    <div class="space-y-2">
                                        <label class="cf-field-label">Adresse 1</label>
                                        <input disabled :value="Items.jsonotherdonne.adresseexpedition.infolibre1" type="text" class="cf-inp" required>
                                    </div>

                                    <div class="space-y-2">
                                        <label class="cf-field-label">Adresse 2</label>
                                        <input disabled :value="Items.jsonotherdonne.adresseexpedition.infolibre2" type="text" class="cf-inp" required>
                                    </div>

                                    <div class="space-y-2">
                                        <label class="cf-field-label">Adresse 3</label>
                                        <input disabled :value="Items.jsonotherdonne.adresseexpedition.infolibre3" type="text" class="cf-inp" required>
                                    </div>

                                </div>

                            </div>

                        </div>

                        <!-- Lignes -->
                        <div class="table-scroll-wrap art-scroll mt-4">
                            <table class="art-table">
                                <thead class="table-head">
                                <tr>
                                    <th class="th" colspan="2">DESIGNATION</th>
                                    <th class="th th--right">PU</th>
                                    <th class="th th--right">QUANTITE</th>
                                    <th class="th th--right">REMISE</th>
                                    <th class="th th--right">MONTANT</th>
                                </tr>
                                </thead>
                                <tbody>

                                <template v-if="listedatatable.length">

                                    <template v-for="(datavalue, index) in listedatatable" :key="index">
                                        <tr class="table-row">
                                            <td class="td" colspan="2">
                                                <span style="font-weight:500;color:var(--cf-ink-strong);">
                                                    <template v-if="datavalue.autredesignation===''">
                                                        {{ datavalue.article.libelle }}
                                                    </template>
                                                    <template v-else>
                                                        {{ datavalue.article.libelle+' ( '+datavalue.autredesignation+' )'}}
                                                    </template>
                                                </span>
                                            </td>
                                            <td class="td td--right">{{ datavalue.pu }}</td>
                                            <td class="td td--right">{{ formatNumber2(datavalue.qtite) }}</td>
                                            <td class="td td--right">{{ datavalue.remise }}</td>
                                            <td class="td td--right">{{ currencyFormatDE(datavalue.calmtntht) }}</td>
                                        </tr>
                                        <tr v-if="datavalue.etatline===2">
                                            <td colspan="20"><div class="cf-note cf-note--danger" style="margin:0.4rem 0;" v-html="datavalue.linemessage"></div></td>
                                        </tr>
                                    </template>

                                </template>

                                <template v-else>
                                    <tr>
                                        <td colspan="20">
                                            <div class="empty-state">
                                                <div class="empty-state__icon"><i class="ri-inbox-line"></i></div>
                                                <p class="empty-state__title">Aucun enregistrement</p>
                                            </div>
                                        </td>
                                    </tr>
                                </template>

                                </tbody>

                                <tfoot v-if="listedatatable.length">

                                <tr class="tfoot-row">
                                    <td class="tfoot-label" colspan="5">MONTANT HT</td>
                                    <td class="tfoot-value">{{currencyFormatDE(Items.mtnt.doccalmtnttotalht)}}</td>
                                </tr>

                                <tr v-if="parseFloat(Items.mtnt.docmtntremise)>0" class="tfoot-row">
                                    <td class="tfoot-label" colspan="5">REMISE</td>
                                    <td class="tfoot-value">{{currencyFormatDE(Items.mtnt.docmtntremise)}}</td>
                                </tr>

                                <tr v-if="parseFloat(Items.mtnt.docmtntaib)>0" class="tfoot-row">
                                    <td class="tfoot-label" colspan="5">{{Items.mtnt.libaib}}</td>
                                    <td class="tfoot-value">{{currencyFormatDE(Items.mtnt.docmtntaib)}}</td>
                                </tr>

                                <tr v-if="parseFloat(Items.mtnt.doctva)>0" class="tfoot-row">
                                    <td class="tfoot-label" colspan="5">TVA (18%)</td>
                                    <td class="tfoot-value">{{currencyFormatDE(Items.mtnt.doctva)}}</td>
                                </tr>

                                <tr class="tfoot-row tfoot-row--net">
                                    <td class="tfoot-label" colspan="5">NET A PAYER</td>
                                    <td class="tfoot-value">{{currencyFormatDE(Items.mtnt.docmtnttotalttc)}}</td>
                                </tr>

                                </tfoot>

                            </table>
                        </div>

                    </div>

                    <!-- Footer -->
                    <div class="cf-dialog-foot">
                        <button @click="close" type="button" class="ti-btn ti-btn-secondary-full">Fermer</button>
                        <button @click="btnimpression" type="button" class="ti-btn ti-btn-primary-full">
                            <i class="ri-printer-line align-middle"></i> Imprimer
                        </button>
                    </div>

                </div>
            </Transition>
        </div>
    </Transition>
</template>

<script>
   /* import templatesite from "@/components/template/apptemplate";
    import appheader from "@/components/template/appheader";
    import appsidebar from "@/components/template/appsidebar";
    import appmenu from "@/components/views/pages/definition/menu";*/
   // import allfunction from "@/allfunction";
   import {currencyFormatDE, FormatNumber, randomString} from "@/allfunction";
    import * as JwtService from "@/common/jwt.service";
    const axios =require('axios');

    export default {
        /* eslint-disable */
        name: "modalform",
        watch: {

            storeqtite: function(oldvalue,newvalue) {

                if(this.ItemsArticle.article!==null ){
                    let montantpu=0;
                    let mqte=0;
                    let $puprixvente=0;
                    let mpu=0;
                    let mpa=0;

                    this.ItemsArticle.qtite=parseFloat(this.storeqtite);

                    if(this.typededocument==='vente'){

                        if (this.Items.jsonotherdonne.mtypprixdevente==='prixvente'){$puprixvente=this.ItemsArticle.article.pu;}
                        if (this.Items.jsonotherdonne.mtypprixdevente==='prixvente1'){$puprixvente=this.ItemsArticle.article.pu1;}
                        if (this.Items.jsonotherdonne.mtypprixdevente==='prixvente2'){$puprixvente=this.ItemsArticle.article.pu2;}
                        if (this.Items.jsonotherdonne.mtypprixdevente==='prixvente3'){$puprixvente=this.ItemsArticle.article.pu3;}
                        if (this.Items.jsonotherdonne.mtypprixdevente==='prixvente4'){$puprixvente=this.ItemsArticle.article.pu4;}
                        if (this.Items.jsonotherdonne.mtypprixdevente==='prixvente5'){$puprixvente=this.ItemsArticle.article.pu5;}
                        if (this.Items.jsonotherdonne.mtypprixdevente==='prixvente6'){$puprixvente=this.ItemsArticle.article.pu6;}
                        if (this.Items.jsonotherdonne.mtypprixdevente==='prixvente7'){$puprixvente=this.ItemsArticle.article.pu7;}




                        //   if (this.disabled===false && this.isblbr===false){
                        if (this.isblbr===true){




                            if (this.ItemsArticle.qtite!==0 ) // recherche du PU dans PV(gestion des prix tarrifaires)
                            {
                                mqte=this.ItemsArticle.qtite;



                                if (this.ItemsArticle.article.pv.length>0 )
                                {
                                    let vm=this


                                    //  montantpu= this.itemArticle.article.pu
                                    montantpu= $puprixvente
                                    this.ItemsArticle.article.pv.forEach(function (line) {

                                    if(line.mtyprix===vm.Items.jsonotherdonne.mtypprixdevente){


                                            if(parseFloat(line.min)<=parseFloat(mqte)){
                                              if(parseFloat(line.max)>=parseFloat(mqte)){

                                                    montantpu=line.pu

                                                }

                                            }
                                        }
                                    })


                                }
                                else{

                                    // montantpu= this.itemArticle.article.pu
                                    montantpu= $puprixvente
                                }




                            }
                            else{
                                // montantpu= this.itemArticle.article.pu
                                montantpu= $puprixvente

                            }



                        }
                        else{

                            if (this.disabled===false){ // l'article n'existe pas dans la liste de la table
                                //montantpu= this.itemArticle.article.pu
                                montantpu= $puprixvente
                            }else{ //existe
                                montantpu= this.ItemsArticle.pu

                            }
                        }



                        //***************************** le bon ok ******************************//
                        if (parseInt(this.Items.jsonotherdonne.appliquetva)===1){ //verifier que sur le document on veut appliquer la tva

                            if (parseInt(this.ItemsArticle.article.tptva)===1){ // Verifier que la tva est appliquable sur cet article


                                if(parseInt(this.ItemsArticle.article.typeprixvente)===1){ // verifier que si le prix est TTC ou pas

                                    //let cal=   parseFloat(this.itemArticle.article.pu)/1.18
                                    let cal=   parseFloat(montantpu)/1.18
                                    // let cal=   parseFloat(this.itemArticle.article.pu)/parseFloat(this.itemArticle.article.typttc)
                                    let fixedcal=cal.toFixed(8);
                                    //this.itemArticle.pu=Math.round(cal)
                                    //this.itemArticle.pu=Math.round(fixedcal)
                                    this.ItemsArticle.pu=fixedcal
                                    this.ItemsArticle.pa=this.ItemsArticle.article.pu
                                    //this.itemArticle.pa=0

                                }
                                else{

                                    // let cal=   parseFloat(this.itemArticle.article.pu)*0.18
                                    let cal=   parseFloat(montantpu)*0.18
                                    this.ItemsArticle.pu=montantpu
                                    this.ItemsArticle.pa=Math.round(cal)

                                }



                            }
                            else{

                                // this.itemArticle.pu=this.itemArticle.article.pu
                                this.ItemsArticle.pu=montantpu
                                this.ItemsArticle.pa=this.ItemsArticle.article.pu
                                //this.itemArticle.pa=0

                            }






                        }
                        else{

                            //  this.itemArticle.pu=this.itemArticle.article.pu
                            this.ItemsArticle.pu=montantpu
                            this.ItemsArticle.pa=this.ItemsArticle.article.pu
                            //this.itemArticle.pa=0

                        }

                    }
                    else{


                        if (parseInt(this.Items.jsonotherdonne.appliquetva)===1){ //verifier que sur le document on veut appliquer la tva

                            if (parseInt(this.ItemsArticle.article.tptva)===1){ // Verifier que la tva est appliquable sur cet article


                                if(parseInt(this.ItemsArticle.article.typeprixvente)===1){ // verifier que si le prix est TTC ou pas

                                    // let cal=   parseInt(this.itemArticle.article.pa)/1.18
                                    let cal=   parseInt(this.ItemsArticle.pa)/1.18
                                    cal=cal.toFixed(8);
                                    this.ItemsArticle.pa=Math.round(cal)
                                    this.ItemsArticle.pu=this.ItemsArticle.article.pu

                                }
                                else{

                                    let cal=   parseInt(this.ItemsArticle.pa)*0.18
                                    //this.itemArticle.pa=this.itemArticle.pa
                                    this.ItemsArticle.pu=Math.round(cal)

                                }



                            }
                            else{

                                //this.itemArticle.pa=this.itemArticle.pa
                                this.ItemsArticle.pu=this.ItemsArticle.article.pu

                            }






                        }
                        else{

                            //  this.itemArticle.pa=this.itemArticle.article.pa
                            this.ItemsArticle.pu=this.ItemsArticle.article.pu

                        }



                    }



                }



            }


        },

        computed:{


            isblbr: function (){

                if (this.typededocument==='vente'){

                    if (this.typedoc==='BL' || this.typedoc==='BRF')
                    {
                        return false;
                    }else{return true;}

                }
                else{  return true; }

            },

            disabledbytypdoc: function (){
                //achat/bon_de_commande
                if (this.typededocument==='achat'){

                    if (this.typedoc==='BC' || this.typedoc==='PF'){
                        return false;
                    }

                    //else{return true;}
                    else{return false;}

                }
                else{  return true; }

            },


            montant()
            {


                let montancalcul=0;

                if(this.ItemsArticle.article!==null ){


                    if (this.ItemsArticle.qtite!==0 )
                    {

                        if(this.typededocument==='vente'){
                            //console.log('this.itemArticle.pu ',this.itemArticle.pu)

                            montancalcul=parseFloat(this.ItemsArticle.pu)*parseFloat(this.ItemsArticle.qtite);

                        }else{

                            montancalcul=parseFloat(this.ItemsArticle.pa)*parseFloat(this.ItemsArticle.qtite);

                        }



                    }


                    if (isNaN(this.ItemsArticle.remise)) {
                        this.ItemsArticle.remise=0;
                    }


                    if (this.ItemsArticle.remise!==0 )
                    {
                        montancalcul=montancalcul-parseFloat(this.ItemsArticle.remise);
                    }

                }
                else {

                    // this.itemArticle.pu=0;


                    if(this.typededocument==='vente'){
                        this.ItemsArticle.pu=0;
                    }else{

                        this.ItemsArticle.pa=0;
                    }


                }
                montancalcul= Math.round(montancalcul)
                this.ItemsArticle.mtnt=montancalcul;

                return montancalcul


                //return this.formatNumber2(Number(montancalcul))
            },



            prixdevente: function (){

                if (this.ItemsArticle.article===null){
                    return 0;
                }
                else{
                    return this.ItemsArticle.pu;
                }

            },



            disableddoc(){

                return this.Items.docnum!==''?true:false;
            },
            stock: function (){

                if (this.ItemsArticle.article!==null){
                    return parseFloat(this.ItemsArticle.article.rstck);
                    //  return "";
                }else{
                    return 0;
                    // return "disabled";
                }

            },





        },
        components: {
           /* templatesite,
            appheader,
            appsidebar,
            appmenu,*/

        },

        data() {
            return {


                storeqtite:0,
                compteprocess:0,



                isdisplayviewarticle:false,
                isdisplay:false,
                messageerror:"",
                messagesucces:"",
                titlemodal:"",
                typedoc:"",
                typededocument:"",
                typeaction:"add",
                datainputlibelleforms: {},
                Items: {},
                alldata: [],

                listedatatable:[],
                listedatatableproduit:[],
                listedatatablecltfrs:[],
                mydocmag:'',
                ItemsArticle:{
                    autredesignation:'',
                    docnum:'',
                    article:null,
                    qtite:0,
                    diqte:0,
                    pu:0,
                    pa:0,
                    mtnt:0,
                    mtntclt:0,
                    remise:0,
                    doc:'',
                    docpid:'',
                    docnumother:'',
                    docmag:'',
                    doctp:'',
                    linekey:'',
                    calmtntht:0,
                    etatline:0,
                    pid:''





                },

            };
        },
        methods: {

            btnimpression(){

               // this.$refs.modalimpressiondoc.show(this.Items);

            },



            calcullistedatatable() {

                let vm=this;


                let $montantnontaxable=0,
                    $montantaib=0,
                    $montantcdtionreglemen=0,
                    $montanttva=0,
                    $montanthtarpvht=0,
                    $montanthtarpvttc=0,
                    $montanttotalht=0,
                    $montanttotalttc=0,
                    $montanttotaltrt =0,
                    $smontantremise=0,
                    $istva=0;

                if (this.listedatatable.length>0){

                    this.listedatatable.forEach(function (line) {

                        if (parseFloat(line.etatline)===0 || parseFloat(line.etatline)===1 || parseFloat(line.etatline)===4 ){




                       // $istva=0;
                        let $datajsonarticle=line.article;
                        let $lignemontantht=line.mtnt;
                        let $mtnt_remise=line.remise;

                        if($datajsonarticle.taxedimposition!=="A"){ //verification si l'article est taxable
                            if(vm.Items.jsonotherdonne.appliquetva==="1" || vm.Items.jsonotherdonne.appliquetva===1) /// verification si on applique la tva sur ce document
                            {
                                //si oui

                                $istva=1;

                                if(parseFloat($datajsonarticle.tptva)===1) /// verification de l'application du tva sur cet article
                                {
                                    //si oui
                                    $montanthtarpvttc=parseFloat($montanthtarpvttc)+parseFloat($lignemontantht);  //montant total des montants HT sur lequelle on applique la tva

                                }
                                else{
                                    $montanthtarpvht=parseFloat($montanthtarpvht)+parseFloat($lignemontantht) ;//montant total des montants HT sur lequelle on pas applique la tva

                                }



                            }
                            else{ // On applique pas la tv a sur le produit


                                $montanthtarpvttc=0;
                                $montanthtarpvht=parseFloat($montanthtarpvht)+parseFloat($lignemontantht); //montant total des montants HT sur lequelle on pas applique la tva

                            }

                        }
                        else{

                            $montantnontaxable=parseFloat($montantnontaxable)+parseFloat($lignemontantht) ;

                        }

                        $smontantremise=parseFloat($smontantremise)+parseFloat($mtnt_remise);
                        }
                    })



                    // $montanttotalht= floatval($montanthtarpvttc)+ floatval($montanthtarpvht);/// calcul du montant total ht sans le montant non taxable
                    $montanttotalht= parseFloat($montanthtarpvttc)+ parseFloat($montanthtarpvht)+parseFloat($montantnontaxable);/// calcul du montant total ht avec le montant non taxable

                    $montanttotaltrt="";

                    if ( $istva===1){

                        $montanttva= parseFloat($montanthtarpvttc)*0.18;////// calcul du montant de la TVA

                    }

                    let $aib=parseInt(vm.Items.jsonotherdonne.aib); // taux de AIB
                    let  $libaib="AIB";
                    if ($aib!==0){
                        $libaib="Montant AIB ("+$aib+" %)";

                        $montantaib=parseFloat($montanttotalht)*(parseInt($aib)/100);

                    }else {$montantaib=0;}


                    let $netfinancier=0;


                    if (this.typedoc==="DAF" || this.typedoc==="BCF" ||
                        this.typedoc==="RF" ||  this.typedoc==="FR" ||
                        this.typedoc==="FRF")
                    {
                        $montantaib=-$montantaib;
                        $netfinancier=$montanttotalht+$montantaib;



                        if ( $istva===1){
                            $montanttva= parseFloat($netfinancier)*0.18;////// calcul du montant de la TVA
                        }

                        $montanttotalttc=parseFloat($netfinancier)+parseFloat($montanttva);

                    }
                    else{

                        /////// calcul du montant ttc

                        $montanttotalttc=parseFloat($montanttotalht)+parseFloat($montantaib)+parseFloat($montanttva);


                    }


                      vm.Items.mtnt={
                        doctva:Math.round($montanttva),
                        docmtnttotalttc:Math.round($montanttotalttc),
                        docmtntaib:Math.round($montantaib),
                        docmtntremise:Math.round($smontantremise),
                        docmtnttotalht:Math.round($montanttotalht),
                        doccalmtnttotalht:Math.round($montanttotalht)+Math.round($smontantremise),
                        libaib:$libaib
                    };



                }
                else{
                    this.Items.mtnt={
                        doctva:Math.round(0),
                        docmtnttotalttc:Math.round(0),
                        docmtntaib:Math.round(0),
                        docmtntremise:Math.round(0),
                        docmtnttotalht:Math.round(0),
                        doccalmtnttotalht:Math.round(0),
                        libaib:"Montant AIB (0 %)"
                    }

                }




            },


            calculSomme(p1,p2){
                var number=Number(p1)+Number(p2)
                return currencyFormatDE(number)
            },

            currencyFormatDE(p1){
                var number=Number(p1)
                return currencyFormatDE(number)
            },

            formatNumber2(p1){
                var number=Number(p1)
                return FormatNumber(number)
            },




            close(){

                this.listedatatableproduit=[];
                this.listedatatable=[];
                this.ItemsArticle={
                    docnum:'',
                    article:null,
                    qtite:0,
                    diqte:0,
                    pu:0,
                    pa:0,
                    calmtntht:0,
                    mtnt:0,
                    mtntclt:0,
                    remise:0,
                    doc:'',
                    docpid:'',
                    docnumother:'',
                    docmag:'',
                    doctp:'',
                    linekey:'',
                    etatline:0,
                    pid:''
                }
                this.isdisplayviewarticle=false;
                this.isdisplay=false;

                this.$emit('closed');

            },



          async  showupdate(titlemodal,typeaction,typedoc,Items,alldata,datainputlibelleforms,typededocument){

                this.titlemodal=titlemodal
                this.typeaction=typeaction
                this.typedoc=typedoc
                this.Items=Items
                this.alldata=alldata
              this.typededocument=typededocument
              this.datainputlibelleforms=datainputlibelleforms
                this.messagesucces="";
                this.messageerror="";


              this.ItemsArticle={
                  docnum:Items.numdoc,
                  article:null,
                  calmtntht:0,
                  qtite:0,
                  diqte:0,
                  pu:0,
                  pa:0,
                  mtnt:0,
                  mtntclt:0,
                  remise:0,
                  doc:'',
                  autredesignation:'',
                  docpid:Items.pid,
                  docnumother:'',
                  docmag:'',
                  doctp:'',
                  linekey:'',
                  etatline:0,
                  pid:''
              }

                if (this.Items.pid!==""){this.isdisplayviewarticle=true}

                this.$store.dispatch('lancerchargement',true)
                const t = this;
                let url=process.env.VUE_APP_API_URL+'/jkebfiuebffeznfoieznofibeubqsyudfyegl745874stock771714dfe/stock/'+this.Items.numdoc+'/'+this.Items.pid+'/open/'+this.$store.state.appsociete+'/'+randomString();
                let response =   axios  .get(url,{
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                })

                let res= await response
                    .then(function (res){
                        t.$store.dispatch('lancerchargement',false)


                        if(res.data.success){


                            t.listedatatableproduit=[];
                            t.listedatatableproduit=res.data.m;

                             t.Items.jsonotherdonne=Items.jsonotherdonne;
                            t.Items.mag=Items.mag;
                            t.Items.pid=Items.pid;
                            t.ItemsArticle.docpid=Items.pid;
                            t.Items.params=Items.params;
                            t.Items.mtnt=Items.mtnt;
                            t.Items.docnum=Items.numdoc;


                            t.Items.docnumother=Items.docnumother;
                            t.Items.docpid=Items.pid;
                            t.Items.pid=Items.pid;
                            t.Items.infodoc=Items.infodoc;
                            t.Items.datedoc=Items.datedoc;
                            t.Items.doctyp=Items.doctyp;
                            t.Items.docobservation=Items.observations;


                            //t.listearticles=response.data.allprod;

                            t.listedatatable=res.data.alllignedoc;
                           t.mydocmag=Items.mag.pid;
                            t.ItemsArticle.docmag=Items.mag.pid;
                            //t.itemArticle.docnum=value.numdoc;
                            t.ItemsArticle.docnum=Items.pid;
                            t.ItemsArticle.doctp=Items.doctyp;
                            t.ItemsArticle.docnumother=Items.docotherref;


                            t.calcullistedatatable();

                            t.isdisplayviewarticle=true;
                            t.isdisplay=true;

                        }
                        else{
                            t.listedatatableproduit=[];
                           // t.isdisplay=true;

                        }


                    })
                    .catch((error)=>{

                            t.$store.dispatch('lancerchargement',false)
                        }
                    )
                    .finally(() =>{

                        t.$store.dispatch('lancerchargement',false)


                    })

            },




            changeItem(value){

                let pid=this.ItemsArticle.pid;
               // let value=event;
                if (pid!=='') return;
                let dataSearch=[];

                if(value!==null){

                    if(this.listedatatable.length !==0){


                        dataSearch = this.listedatatable.filter(function (article) {

                            return  article.article.pid ===value.pid
                            //return article.pidar.includes(value.pid);
                        });


                        if(dataSearch.length !==0){
                            toastr['error']( value.libelle+' existe déjà dans la liste.',"<b></b>");
                            this.ItemsArticle.article=null;
                            this.ItemsArticle.qtite=0;
                            this.ItemsArticle.pu= 0;
                            this.storeqtite=0;

                            let mvalue=dataSearch[0];
                            ///  let qte=this.formatNumber2(Number(value.qtite));
                            let qte=mvalue.qtite;
                            var mitemarticle=this.ItemsArticle
                            this.disabled=true;

                            this.ItemsArticle={
                                article:mvalue.article,
                                qtite:qte,
                                diqte:0,
                                pu:mvalue.ppu,
                                pa:mvalue.pa,
                                mtnt:mvalue.mtnt ,
                                docnumother:mitemarticle.docnumother ,
                                remise:mvalue.remise,
                                calmtntht:mvalue.calmtntht,
                                //docnum:value.numdoc,
                                autredesignation:value.autredesignation,
                                doctp:mvalue.doctyp,
                                pid:mvalue.pid,
                                docpid:mvalue.docnum,
                                docnum:mvalue.docnum
                            };

                            this.storeqtite=qte;






                        }else{
                            // console.log('this.itemArticle.article.pu',this.itemArticle.article.pu)
                            //this.itemArticle.pu= this.itemArticle.article.pu

                            this.gestionPu();


                        }


                    }else{
                        // console.log('this.itemArticle.article.pu',this.itemArticle.article.pu)
                        // this.itemArticle.pu=this.itemArticle.article.pu
                        //this.itemArticle.pu= this.itemArticle.article.pu
                        this.gestionPu();
                    }


                }


            },

            gestionPu(){


                if(this.typededocument==='vente'){

                    let $puprixvente=0;

                    //***************************** le bon ok ******************************
                    if (parseInt(this.Items.jsonotherdonne.appliquetva)===1){ //verifier que sur le document on veut appliquer la tva

                        if (parseInt(this.ItemsArticle.article.tptva)===1){ // Verifier que la tva est appliquable sur cet article


                            if(parseInt(this.ItemsArticle.article.typeprixvente)===1){ // verifier que si le prix est TTC ou pas

                                if (this.Items.jsonotherdonne.mtypprixdevente==='prixvente'){$puprixvente=this.ItemsArticle.article.pu;}
                                if (this.Items.jsonotherdonne.mtypprixdevente==='prixvente1'){$puprixvente=this.ItemsArticle.article.pu1;}
                                if (this.Items.jsonotherdonne.mtypprixdevente==='prixvente2'){$puprixvente=this.ItemsArticle.article.pu2;}
                                if (this.Items.jsonotherdonne.mtypprixdevente==='prixvente3'){$puprixvente=this.ItemsArticle.article.pu3;}
                                if (this.Items.jsonotherdonne.mtypprixdevente==='prixvente4'){$puprixvente=this.ItemsArticle.article.pu4;}
                                if (this.Items.jsonotherdonne.mtypprixdevente==='prixvente5'){$puprixvente=this.ItemsArticle.article.pu5;}
                                if (this.Items.jsonotherdonne.mtypprixdevente==='prixvente6'){$puprixvente=this.ItemsArticle.article.pu6;}
                                if (this.Items.jsonotherdonne.mtypprixdevente==='prixvente7'){$puprixvente=this.ItemsArticle.article.pu7;}



                                // let cal=   parseFloat(this.itemArticle.article.pu)/1.18
                                let cal=   parseFloat($puprixvente)/1.18
                                // let cal=   parseFloat(this.itemArticle.article.pu)/parseFloat(this.itemArticle.article.typttc)
                                let fixedcal=cal.toFixed(8);
                                //this.itemArticle.pu=Math.round(cal)
                                //this.itemArticle.pu=Math.round(fixedcal)
                                this.ItemsArticle.pu=fixedcal
                                //this.itemArticle.pa=this.itemArticle.article.pu
                                this.ItemsArticle.pa=0

                            }
                            else{
                                if (this.Items.jsonotherdonne.mtypprixdevente==='prixvente'){$puprixvente=this.ItemsArticle.article.pu;}
                                if (this.Items.jsonotherdonne.mtypprixdevente==='prixvente1'){$puprixvente=this.ItemsArticle.article.pu1;}
                                if (this.Items.jsonotherdonne.mtypprixdevente==='prixvente2'){$puprixvente=this.ItemsArticle.article.pu2;}
                                if (this.Items.jsonotherdonne.mtypprixdevente==='prixvente3'){$puprixvente=this.ItemsArticle.article.pu3;}
                                if (this.Items.jsonotherdonne.mtypprixdevente==='prixvente4'){$puprixvente=this.ItemsArticle.article.pu4;}
                                if (this.Items.jsonotherdonne.mtypprixdevente==='prixvente5'){$puprixvente=this.ItemsArticle.article.pu5;}
                                if (this.Items.jsonotherdonne.mtypprixdevente==='prixvente6'){$puprixvente=this.ItemsArticle.article.pu6;}
                                if (this.Items.jsonotherdonne.mtypprixdevente==='prixvente7'){$puprixvente=this.ItemsArticle.article.pu7;}


                                //let cal=   parseFloat(this.itemArticle.article.pu)*0.18
                                let cal=   parseFloat($puprixvente)*0.18
                                //this.itemArticle.pu=this.itemArticle.article.pu
                                this.ItemsArticle.pu=$puprixvente
                                this.ItemsArticle.pa=Math.round(cal)

                            }



                        }
                        else{

                            if (this.Items.jsonotherdonne.mtypprixdevente==='prixvente'){$puprixvente=this.ItemsArticle.article.pu;}
                            if (this.Items.jsonotherdonne.mtypprixdevente==='prixvente1'){$puprixvente=this.ItemsArticle.article.pu1;}
                            if (this.Items.jsonotherdonne.mtypprixdevente==='prixvente2'){$puprixvente=this.ItemsArticle.article.pu2;}
                            if (this.Items.jsonotherdonne.mtypprixdevente==='prixvente3'){$puprixvente=this.ItemsArticle.article.pu3;}
                            if (this.Items.jsonotherdonne.mtypprixdevente==='prixvente4'){$puprixvente=this.ItemsArticle.article.pu4;}
                            if (this.Items.jsonotherdonne.mtypprixdevente==='prixvente5'){$puprixvente=this.ItemsArticle.article.pu5;}
                            if (this.Items.jsonotherdonne.mtypprixdevente==='prixvente6'){$puprixvente=this.ItemsArticle.article.pu6;}
                            if (this.Items.jsonotherdonne.mtypprixdevente==='prixvente7'){$puprixvente=this.ItemsArticle.article.pu7;}


                            this.ItemsArticle.pu=$puprixvente
                            this.ItemsArticle.pa=0
                            /*this.itemArticle.pu=this.itemArticle.article.pu
                            this.itemArticle.pa=this.itemArticle.article.pu*/

                        }






                    }
                    else{

                        /* this.itemArticle.pu=this.itemArticle.article.pu
                         this.itemArticle.pa=this.itemArticle.article.pu*/

                        if (this.Items.jsonotherdonne.mtypprixdevente==='prixvente'){$puprixvente=this.ItemsArticle.article.pu;}
                        if (this.Items.jsonotherdonne.mtypprixdevente==='prixvente1'){$puprixvente=this.ItemsArticle.article.pu1;}
                        if (this.Items.jsonotherdonne.mtypprixdevente==='prixvente2'){$puprixvente=this.ItemsArticle.article.pu2;}
                        if (this.Items.jsonotherdonne.mtypprixdevente==='prixvente3'){$puprixvente=this.ItemsArticle.article.pu3;}
                        if (this.Items.jsonotherdonne.mtypprixdevente==='prixvente4'){$puprixvente=this.ItemsArticle.article.pu4;}
                        if (this.Items.jsonotherdonne.mtypprixdevente==='prixvente5'){$puprixvente=this.ItemsArticle.article.pu5;}
                        if (this.Items.jsonotherdonne.mtypprixdevente==='prixvente6'){$puprixvente=this.ItemsArticle.article.pu6;}
                        if (this.Items.jsonotherdonne.mtypprixdevente==='prixvente7'){$puprixvente=this.ItemsArticle.article.pu7;}


                        this.ItemsArticle.pu=$puprixvente
                        this.ItemsArticle.pa=0
                        /*this.itemArticle.pu=this.itemArticle.article.pu
                        this.itemArticle.pa=this.itemArticle.article.pu*/


                    }

                }
                else{



                    if (parseInt(this.Items.jsonotherdonne.appliquetva)===1){ //verifier que sur le document on veut appliquer la tva

                        if (parseInt(this.ItemsArticle.article.tptva)===1){ // Verifier que la tva est appliquable sur cet article


                            if(parseInt(this.ItemsArticle.article.typeprixvente)===1){ // verifier que si le prix est TTC ou pas

                                let cal=   parseInt(this.ItemsArticle.article.pa)/1.18
                                cal=cal.toFixed(8);
                                this.ItemsArticle.pa=Math.round(cal)
                                this.ItemsArticle.pu=this.ItemsArticle.article.pu

                            }
                            else{

                                let cal=   parseInt(this.ItemsArticle.article.pa)*0.18
                                this.ItemsArticle.pa=this.ItemsArticle.article.pa
                                this.ItemsArticle.pu=Math.round(cal)

                            }



                        }
                        else{

                            this.ItemsArticle.pa=this.ItemsArticle.article.pa
                            this.ItemsArticle.pu=this.ItemsArticle.article.pu

                        }






                    }
                    else{

                        this.ItemsArticle.pa=this.ItemsArticle.article.pa
                        this.ItemsArticle.pu=this.ItemsArticle.article.pu

                    }



                }



                //  this.itemArticle.qtite=1;

            },



        },
        mounted() {

            // this.loaddata();
        }




    }
</script>

<style scoped>
/* Charte cf-/ds- : tokens uniquement (light-only) */
.cf-overlay { position:fixed; inset:0; z-index:1000; display:flex; align-items:center; justify-content:center; padding:1rem; background:rgb(15 23 42 / 0.45); }
.cf-dialog { width:100%; background:#fff; border-radius:var(--cf-radius); box-shadow:var(--cf-shadow-md); display:flex; flex-direction:column; max-height:92vh; overflow:hidden; }
.cf-dialog--xl { max-width:960px; }
.cf-dialog-head { display:flex; align-items:center; justify-content:space-between; padding:1rem 1.25rem; border-bottom:1px solid var(--cf-border); flex-shrink:0; }
.cf-dialog-title { margin:0; font-size:0.95rem; font-weight:700; color:var(--cf-ink-strong); }
.cf-dialog-close { height:2rem; width:2rem; flex-shrink:0; display:inline-flex; align-items:center; justify-content:center; border-radius:var(--cf-radius-sm); border:none; background:var(--cf-surface-alt); color:var(--cf-muted); cursor:pointer; transition:all .15s; }
.cf-dialog-close:hover { background:#fee2e2; color:rgb(var(--danger)); }
.cf-dialog-body { padding:1.1rem 1.25rem; overflow-y:auto; flex:1; }
.cf-dialog-foot { display:flex; align-items:center; justify-content:flex-end; gap:0.6rem; padding:0.9rem 1.25rem; border-top:1px solid var(--cf-border); background:var(--cf-surface); flex-shrink:0; }

.cf-tabpanels { padding-top:1rem; }

.cf-field-label { display:block; font-size:0.72rem; text-transform:uppercase; letter-spacing:0.03em; font-weight:600; color:var(--cf-muted); margin-bottom:6px; }
.cf-inp { width:100%; height:40px; padding:0 12px; border-radius:var(--cf-radius-sm); border:1px solid rgb(var(--input-border,203 213 225)); background:#fff; color:var(--cf-ink); font-size:0.82rem; outline:none; transition:border-color 0.2s, box-shadow 0.2s; }
.cf-inp:focus { border-color:rgb(var(--primary)); box-shadow:0 0 0 3px rgb(var(--primary) / 0.10); }
.cf-inp:disabled { background:var(--cf-surface); color:var(--cf-muted); cursor:not-allowed; }
.cf-textarea { height:auto; min-height:56px; padding:8px 12px; resize:vertical; }

.table-scroll-wrap { overflow:auto; }
.art-scroll { max-height:34vh; }
.art-table { width:100%; text-align:left; font-size:13px; border-collapse:collapse; min-width:600px; }
.th { position:sticky; top:0; z-index:2; padding:0.7rem 1rem; font-weight:600; font-size:0.75rem; color:var(--cf-ink); background:var(--cf-surface-alt); border-bottom:1px solid var(--cf-border); white-space:nowrap; letter-spacing:0.02em; text-align:left; }
.th--center { text-align:center; }
.th--right { text-align:right; }
.table-row { border-bottom:1px solid var(--cf-surface-alt); transition:background-color 0.15s; }
.table-row:hover { background:var(--cf-surface); }
.td { padding:0.65rem 1rem; font-size:0.82rem; color:var(--cf-ink); vertical-align:middle; white-space:nowrap; }
.td--center { text-align:center; }
.td--right { text-align:right; }
.row-number { color:var(--cf-faint); font-size:0.75rem; font-variant-numeric:tabular-nums; }

.tfoot-row .tfoot-label { text-align:right; padding:0.55rem 1rem; font-size:0.75rem; font-weight:600; text-transform:uppercase; letter-spacing:0.02em; color:var(--cf-muted); border-top:1px solid var(--cf-border); }
.tfoot-row .tfoot-value { text-align:right; padding:0.55rem 1rem; font-size:0.85rem; font-weight:600; color:var(--cf-ink-strong); border-top:1px solid var(--cf-border); white-space:nowrap; font-variant-numeric:tabular-nums; }
.tfoot-row--net .tfoot-label, .tfoot-row--net .tfoot-value { font-weight:700; color:rgb(var(--primary)); background:rgb(var(--primary) / 0.06); }

.empty-state { padding:2rem 1.5rem; text-align:center; }
.empty-state__icon { font-size:36px; color:var(--cf-faint); margin-bottom:10px; }
.empty-state__title { font-size:0.9rem; font-weight:600; color:var(--cf-ink-strong); margin:0; }

.modal-fade-enter-active, .modal-fade-leave-active { transition:opacity 0.25s ease; }
.modal-fade-enter-from, .modal-fade-leave-to { opacity:0; }
.modal-slide-enter-active, .modal-slide-leave-active { transition:all 0.25s ease; }
.modal-slide-enter-from, .modal-slide-leave-to { opacity:0; transform:translateY(-16px); }

.art-scroll::-webkit-scrollbar { width:6px; height:6px; }
.art-scroll::-webkit-scrollbar-thumb { background:#cbd5e1; border-radius:3px; }

@media (max-width:768px) { .cf-dialog--xl { max-width:100%; } }
</style>
